<template>
  <div>
    <h1>Registrar Taxímetro</h1>
    <b-alert
      :show="dismissCountDown"
      dismissible
      :variant="mensaje.color"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      {{mensaje.texto}}
    </b-alert>
    <div class="card">
      <div class="card-body">
        <h5 class="mb-4"></h5>
        <a-form :form="form" @submit.prevent="handleSubmit" layout="vertical">
          <div class="row">
            <div class="col-md-6">
              <a-form-item label="Número de Serie">
                <a-input
                  placeholder="Número de Serie"
                  v-model="$v.addTaximeter.serialNumber.$model"
                />
                <small class="text-danger" v-if="!$v.addTaximeter.serialNumber.required">Campo requerido</small>
                <small class="text-danger" v-if="!$v.addTaximeter.serialNumber.alphaNum">Ingresa un número de serie válido</small>
              </a-form-item>
            </div>
            <div class="col-12">
              <a-form-item>
                <button
                 :disabled="disabledButton"
                  type="submit"
                  class="btn btn-light px-5"
                >
                  Guardar
                </button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
import { required, alphaNum } from 'vuelidate/lib/validators'
import gql from 'graphql-tag'
// import { encrypt } from '@/config/headers'
export default {
  data: function () {
    return {
      mensaje: { color: '', texto: '' },
      dismissSecs: 5,
      dismissCountDown: 0,

      disabledButton: false,
      error: null,
      form: this.$form.createForm(this),
      addTaximeter: {
        serialNumber: null,
      },
      id: null,
    }
  },
  apollo: {
    getVehicleId: {
      query: gql`
        query getTaximeterById($id: Int!) {
          getTaximeterById(id: $id) {
            id
            serialNumber       
          }
        }
      `,
      context: {
        // headers: encrypt(new Date().getTime()),
      },
      error (erro) {
        console.log(erro)
      },
      variables() {
        return {
          id: this.id ? parseInt(this.id) : 1,
        }
      },
      skip() {
        return this.skipQuery
      },
    },
  },
  created() {
    if (this.$route.params.id != null) {
      this.bandera = true
      this.$apollo.queries.getVehicleId.skip = false
    }
  },
  methods: {
    async handleSubmit () {
      if (this.$v.$invalid) {
        this.mensaje.texto = 'Campos inválidos, comprueba tus datos'
        this.mensaje.color = 'danger'
        this.showAlert()
        return
      }

      this.disabledButton = true
      if (this.id != null) {

      } else {
        await this.$apollo.mutate({
          mutation: gql`mutation ($serialNumber: String) {
         createTaximeter(taximeter: {
                serialNumber:$serialNumber
            }){
                serialNumber
            }
        }`,
          context: {
            // headers: encrypt(new Date().getTime()),
          },
          variables: {
            serialNumber: this.addTaximeter.serialNumber,
          },
        })
          .then(res => {
            this.$router.push('/taximeters/getTaximeters')
          })
          .catch(error => {
            this.disabledButton = false
            console.log(error)
            this.mensaje.texto = 'Ocurrió un error, intentalo de nuevo'
            this.mensaje.color = 'warning'
            this.showAlert()
          })
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
  },
  validations: {
    addTaximeter: {
      serialNumber: { required, alphaNum },
    },
  },
}
</script>

<style>

</style>
